import { IEntityContentField } from '../../../lib/interfaces/Common';

/* eslint-disable import/prefer-default-export */
export const getEditorsNumber = (
	field: IEntityContentField,
	CodeEditorOptions: any,
) => {
	const editorOption: any = Object.values(CodeEditorOptions).find(
		(value: any) => value?.value === field.content,
	);
	if (editorOption) {
		return editorOption.editorsNumber;
	}
	return 1;
};

export const getEditorsHeight = ({
	isHorizontalView,
	editorsNumber,
}: {
	isHorizontalView: boolean;
	editorsNumber: number;
}) => {
	const wHeight = window.innerHeight;
	const headerHeight = 56;
	const editorHeader = 39;
	if (isHorizontalView) {
		return (wHeight - headerHeight - editorHeader - 100) / 2;
	}
	console.log(
		'300 + editorHeader) * editorsNumber',
		editorHeader,
		editorsNumber,
	);
	return (300 + editorHeader) * editorsNumber;
};

export const getResultBlockHeight = ({
	isHorizontalView,
	editorsNumber,
}: {
	isHorizontalView: boolean;
	editorsNumber: number;
}) => {
	const wHeight = window.innerHeight;
	const headerHeight = 56;
	const editorHeader = 39;
	if (isHorizontalView) {
		return (wHeight - headerHeight - editorHeader) / 2;
	}
	const editorHeight = getEditorsHeight({
		isHorizontalView,
		editorsNumber,
	});
	return editorHeight;
};

export const CodeEditorOptions = {
	HTML: {
		label: 'HTML',
		value: 'html',
		editorsNumber: 1,
	},
	HTML_CSS: {
		label: 'HTML & CSS',
		value: 'html_css',
		editorsNumber: 2,
	},
	HTML_SCSS: {
		label: 'HTML & SCSS',
		value: 'html_scss',
		editorsNumber: 2,
	},
	HTML_CSS_JS: {
		label: 'HTML & CSS & JS',
		value: 'html_css_js',
		editorsNumber: 3,
	},
	JS: {
		label: 'JS',
		value: 'js',
		editorsNumber: 1,
	},
	JS_TESTS: {
		label: 'JS Task with tests',
		value: 'js_task_with_tests',
		editorsNumber: 1,
	},
};

export const getFilesEditorHeight = (
	isExpanded: boolean,
	isResult: boolean,
) => {
	if (!isResult) {
		return isExpanded ? `${window.innerHeight - 56.5 - 30}px` : '300px';
	}
	return isExpanded ? `${window.innerHeight - 56.5 - 30}px` : '300px';
};
